import { lazyWithRetries } from '@globals/lazyWithRetries'
import AppPaths from '@globals/paths'
import StandardPageLayout from '@layouts/standardPageLayout'
import RouteLoading from '@shared/routing/RouteLoading'
import { T } from '@transifex/react'
import { Suspense } from 'react'
import { RouteObject } from 'react-router'

const HrisIntegrationRoute = lazyWithRetries(() => import('./'))
const BatchAddStaffRoute = lazyWithRetries(() => import('./batchAdd'))

const routes: RouteObject[] = [
  {
    path: AppPaths.tenant.admin.hrisIntegrations(':tab'),
    element: (
      <StandardPageLayout
        elementId="hrisIntegrationsRoute"
        title={<T _str="HRIS integration" />}
        maxWidth={1440}>
        <Suspense fallback={<RouteLoading />}>
          <HrisIntegrationRoute />
        </Suspense>
      </StandardPageLayout>
    ),
  },
  {
    path: AppPaths.tenant.admin.batchAddStaff(':batchId'),
    element: (
      <StandardPageLayout
        elementId="batchAddStaffRoute"
        title={<T _str="Add to Kudos" />}
        maxWidth={900}>
        <Suspense fallback={<RouteLoading />}>
          <BatchAddStaffRoute />
        </Suspense>
      </StandardPageLayout>
    ),
  },
]

export default routes
